import * as Yup from 'yup';
import { MESSAGE_ONLY_CYRILLIC_SYMBOLS, MESSAGE_REQUIRED } from '@/utils/validation-utils';
import { isNotBlank } from '@/utils/string-utils';

export const prisonerNameSchema: Yup.StringSchema = Yup.string()
  .test('notEmpty', MESSAGE_REQUIRED, (value: string | undefined): boolean => {
    return isNotBlank(value);
  })
  .matches(/^[А-яЁё\s]+$/, MESSAGE_ONLY_CYRILLIC_SYMBOLS)
  .required(MESSAGE_REQUIRED);
